import React, { useRef, useEffect } from 'react'
import moment from 'moment/moment'

import {
  YearsFilter,
  YearItem,
  MonthsFilter,
  MonthItem,
  MonthsContainer
} from './styles'

import 'moment/locale/pt-br'

const DateFilter = (props) => {
  const [selectedDate, setSelectedDate] = props.selectedDate
  const currentDate = moment()
  const currentYear = currentDate.year()
  const currentMonth = currentDate.month()

  const years = [currentYear - 1, currentYear]
  const months = moment.months()

  const selectedYear = selectedDate.year()
  const selectedMonth = selectedDate.month()

  const MonthRef = useRef()
  const filteredMonths = months.filter((month, index) => selectedYear !== currentYear || index <= currentMonth)

  useEffect(() => {
    const activeMonth = MonthRef.current.querySelector('.active') || MonthRef.current
    activeMonth.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
  }, [])

  const handleChangeDate = (dateValue, datePart) => {
    const newDate = selectedDate.clone()
    newDate.set(datePart, dateValue)

    const isCurrentYear = newDate.year() === currentYear

    // Ao trocar o ano, se a data do filtro é maior do que a data atual, setamos o mês atual
    if (datePart === 'year' && newDate > currentDate) {
      newDate.set('month', currentMonth)
    }

    const isSameMonthAndYear = newDate.month() === currentMonth && isCurrentYear

    // Se foi selecionado o mês e ano atual setamos o dia atual também, se não, setamos o último dia do mês
    if (isSameMonthAndYear) {
      newDate.set('date', currentDate.date())
    } else {
      newDate.endOf('month')
    }

    setSelectedDate(newDate)
  }

  return (
    <>
      <YearsFilter>
        {years.map((year, index) => (
          <YearItem key={index} onClick={() => handleChangeDate(year, 'year')} selected={selectedYear === year}>{year}</YearItem>
        ))}
      </YearsFilter>
      <MonthsContainer ref={MonthRef}>
        <MonthsFilter>
          {filteredMonths.map((month, index) => {
            const isSelectedMonth = selectedMonth === index
            return (
              <MonthItem
                key={index}
                onClick={() => handleChangeDate(index, 'month')}
                className={isSelectedMonth ? 'active' : ''}
                selected={isSelectedMonth}>
                {month}
              </MonthItem>
            )
          })}
        </MonthsFilter>
      </MonthsContainer>
    </>
  )
}

export default DateFilter
